import styled from "styled-components";

export const SelectToggleButtonStyled = styled.div`
    padding: 16px 40px 16px 16px;
    border: 1px solid var(--color-base);
    border-radius: 16px;
    background: var(--color-base);
    position: relative;
    cursor: pointer;
    width: 100%;
    color: var(--color-secondary-active);
    font-weight: 400;
    display: flex;
    align-items: center;

    ${({ isOpen }) => isOpen && 'border-color: var(--color-main);'}
    ${({ isOpen }) => isOpen && 'color: var(--color-white);'}

    &:hover {
        color: var(--color-white);
        border-color: var(--color-main);
        
        .right-icon svg {
            fill: var(--color-white);
        }
    }
  
    &.sm {
        padding: 8px 40px 8px 16px;
        .right-icon {
          right: 8px;
        }
    }
`;

export const SelectToggleButtonStyledRightIconStyled = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%);

    svg {
        fill: var(--icon-primary-color);
        ${({ isOpen }) => isOpen && 'transform: rotate(180deg);'}
        transition: transform 200ms ease, fill 200ms ease;
    }
`;